import { Tooltip } from "react-bootstrap";
import styled from "styled-components";

export const CustomTooltip = styled(Tooltip)`
  opacity: 1 !important;

  /* .tooltip-arrow {
        color: #808080 !i;
    } */
  .tooltip-arrow::before {
    border-bottom-color: rgba(33, 33, 33, 0.9) !important;
    border-top-color: rgba(33, 33, 33, 0.9) !important;
  }

  .tooltip-inner {
    background-color: rgba(33, 33, 33, 0.9) !important;
    border-color: none;
    color: #fff;
    /* font-size: 0.75rem;
    font-family: "Poppin", sans-serif;
    font-weight: 500; */
    font-family: "Work Sans";
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem; /* 127.273% */
    letter-spacing: 0.00688rem;
  }
`;

export const SidebarTooltip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-arrow::before {
    border-right-color: rgba(33, 33, 33, 0.9) !important;
  }

  .tooltip-inner {
    background-color: rgba(33, 33, 33, 0.9) !important;
    border-color: none;
    color: #fff;
    /* font-size: 0.75rem;
    font-family: "Poppin", sans-serif;
    font-weight: 500; */

    font-family: "Work Sans";
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem; /* 127.273% */
    letter-spacing: 0.00688rem;
    text-align: ${(props: any) => props.textAlignment};
  }
`;

export const GoalsHubTooltip = styled(Tooltip)`
  // inset: 8px auto auto 0px !important;
  z-index: 1300 !important;

  .tooltip-arrow::before {
    border-right-color: ${(props) =>
    props.placement === "right" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
    border-bottom-color: ${(props) =>
    props.placement === "bottom" ? "rgba(33, 33, 33, 0.9)!important" : "transparent"};
    border-left-color: ${(props) =>
    props.placement === "left" ? "rgba(33, 33, 33, 0.9)!important" : "transparent"};
    border-top-color: ${(props) =>
    props.placement === "top" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
  }

  .tooltip-inner {
    padding: 0.5rem;
    color: #fff;
    border-radius: 0.5rem;
    background: rgba(33, 33, 33, 0.9) !important;

    /* Desktop/Paragraph/Medium */
    font-family: Work Sans;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem; /* 127.273% */
    letter-spacing: 0.00688rem;
    max-width: ${(props: any) => props.maxWidth ? props.maxWidth : ''};

    .pointsContainer {
      text-align: left;
      ul {
        /* padding-left: 0rem; */
        padding-left: 1rem;
        margin-bottom: 0rem;

        li {
          text-align: left;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
`;

export const ProductTableToolTip = styled(Tooltip)`
  // inset: 8px auto auto 0px !important;

  .tooltip-arrow::before {
    border-right-color: ${(props) =>
    props.placement === "right" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
    border-bottom-color: ${(props) =>
    props.placement === "bottom" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
    border-left-color: ${(props) =>
    props.placement === "left" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
    border-top-color: ${(props) =>
    props.placement === "top" ? "rgba(33, 33, 33, 0.9) !important" : "transparent"};
  }

  .tooltip-inner {
    padding: 0.62rem;
    color: #fff;
    border-radius: 0.25rem;
    background-color: rgba(33, 33, 33, 0.9) !important;
    min-width: 350px;

    /* Desktop/Paragraph/Medium */
    font-family: Work Sans;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem; /* 127.273% */
    letter-spacing: 0.00688rem;
  }
`;

export const AccessUsersToolTip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-arrow::before {
    border-right-color: rgba(33, 33, 33, 0.9) !important; 
  }

  .tooltip-inner {
    background-color: rgba(33, 33, 33, 0.9);
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 17.25rem;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .listTitle {
    font-family: "Quicksand";
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.00938rem;
  }

  .listItem {
    font-family: "Work Sans";
    font-size: 0.6875rem !important;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem; /* 127.273% */
    letter-spacing: 0.00688rem;
    margin: 0 0 0 1.25rem;
    padding: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const IBtnTooltip = styled(Tooltip)`
    opacity: 1 !important;

    .tooltip-arrow::before {
    border-right-color: #fff !important;
    }
    

    .tooltip-inner {
      background-color: #fff;
      padding: 0.75rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      justify-content: flex-start;
      align-items: flex-start;
      /* width: 100%; */
      box-shadow: -2px -2px 8px 0px rgba(0, 0, 0, 0.10), 2px 4px 8px 0px rgba(0, 0, 0, 0.15);
      border-radius: 0.5rem !important;
      border: 1px solid #fdecec;
      background-color: #fff !important;
      width: 17.25rem !important;
      max-width: 17.25rem;
    }

    .iBtnContainer {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 0.5rem;
      text-align: left;
    }

    .title {
      font-family: Quicksand;
      font-size: 0.9375rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.00938rem;
      color: #212121;
    }

    .subTitle {
      font-family: "Work Sans";
      font-size: 0.6875rem;
      font-style: normal;
      font-weight: 500;
      line-height: 0.875rem; /* 127.273% */
      letter-spacing: 0.00688rem;
      color: #212121;
    }
`;

export const SIPromoStyled = styled(Tooltip)`
  opacity: 1 !important;
  max-width: 242px !important;

  .tooltip-arrow {
    top: 12px !important;
  }

  .tooltip-arrow::before {
    border-right-color: #1e1e1e !important;
    width: 11.67px !important;
    height: 11.67px !important;
  }

  .tooltip-inner {
    background-color: #1e1e1e !important;
    border-radius: 8px;
    padding: 12px;
    width: 242px;
    max-width: 242px;
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const DataSourcesToolTip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-arrow::before {
    border: none !important;
  }

  .tooltip-inner {
    background-color: rgba(33, 33, 33, 0.9) !important;
    border-color: none;
    color: #fff;
    font-size: 0.75rem;
    font-family: "Poppin", sans-serif;
    font-weight: 500;
    text-align: left;

    display: flex;
    border-radius: 4px;
    background-color: rgba(33, 33, 33, 0.9);
    flex-direction: column;
    gap: 10px;
    padding: 8px 0px;
    width: 170px;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .imgContainer {
    background-color: #fff;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img {
    height: 13px;
    width: 13px;
  }

  .container {
    display: flex;
    gap: 7px;
  }
`;
